import { Component, ElementRef, Inject, OnInit } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { Lightbox } from 'ngx-lightbox'
import { AlertService } from '../../_services/index'
import { DataService } from '../../data.service'
import { NavigationService } from '../../navigation/navigation.service'
import { environment } from './../../../environments/environment'

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {
  userData: any = {}
  model: any
  btnDisable: boolean
  updatedUserData: any = {}
  base64textString: any
  appConstant: any
  errorInfo: any = {}
  logoStatus: any = false
  loginAdmin = ''
  albumLogo: any = []
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertService: AlertService,
    private dataService: DataService,
    private router: Router,
    private navigationService: NavigationService,
    private el: ElementRef,
    private lightbox: Lightbox
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem('adminInfo')) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem('adminInfo'),
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      this.loginAdmin = user.admin_type
    }

    this.appConstant = environment
    if (localStorage.getItem('adminInfo')) {
      const getUserData: any = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem('adminInfo'),
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      this.model = JSON.parse(JSON.stringify(getUserData))
      if (this.model.image) {
        const imgSrc: any = environment.adminImage + this.model.image
        const title: any = this.model.name
        const album: any = {
          src: imgSrc,
          caption: title,
          id: this.model.public_id,
        }
        this.albumLogo.push(album)
      }
    }
  }
  submit(valid: any): void {
    if (valid) {
      this.btnDisable = true
      this.model.public_id = this.model.public_id
      this.navigationService.updateProfile(this.model).subscribe(
        (data: any) => {
          this.btnDisable = false
          this.updatedUserData = JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem('adminInfo'),
              environment.secretKey
            ).toString(CryptoJS.enc.Utf8)
          )
          if (this.model.userType !== 'brand') {
            this.updatedUserData.first_name = this.model.first_name
            this.updatedUserData.last_name = this.model.last_name
            this.updatedUserData.image = this.model.image
          } else {
            this.updatedUserData.name = this.model.name
            this.updatedUserData.location = this.model.location
            this.updatedUserData.website_link = this.model.website_link
            this.updatedUserData.logo = this.model.logo
          }
          this.updatedUserData.mobile_number = this.model.mobile_number
          this.updatedUserData.email = this.model.email

          const updatedUserData: any = CryptoJS.AES.encrypt(
            JSON.stringify(this.updatedUserData),
            environment.secretKey
          ).toString()
          localStorage.setItem('adminInfo', updatedUserData)

          this.dataService.updateProfileService(this.updatedUserData)

          this.alertService.success('Account updated successfully.')
          this.dialogRef.close('')
        },
        (err: any) => {
          if (err.error.mobile_number) {
            this.errorInfo = err.error.mobile_number[0]
          }
          this.btnDisable = false
          setTimeout(() => {
            this.scrollToFirstInvalidControl()
          }, 1000)
          this.alertService.error(err.error.mobile_number)
        }
      )
    }
  }
  private scrollToFirstInvalidControl(): void {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector('form .input-error')
    if (firstInvalidControl) {
      window.scroll({
        top: this.getTopOffset(firstInvalidControl),
        left: 0,
        behavior: 'smooth',
      })
      setTimeout(() => {
        firstInvalidControl.focus()
      }, 800)
    }
  }
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset: any = 50
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset
  }
  closeModel(): void {
    this.dialogRef.close('')
  }
  handleFileSelect(evt: any, imagetype: any): void {
    const files: any = evt.target.files
    if (files.length > 0) {
      const file: any = files[0]
      const type: any = file.type
      const imageType: any = type.split('/')
      this.model.type = imagetype
      if (files && file) {
        const reader: any = new FileReader()
        reader.onload = this._handleReaderLoaded_school.bind(this)
        this.navigationService
          .uploadProfile(file, this.model.userType)
          .subscribe(
            (data: any) => {
              this.updatedUserData = JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem('adminInfo'),
                  environment.secretKey
                ).toString(CryptoJS.enc.Utf8)
              )
              if (this.model.userType === 'brand') {
                this.updatedUserData.logo = data.logo
                this.model.logo = data.logo
              } else {
                this.model.image = data.image
                this.updatedUserData.image = data.image
              }
              // const updatedUserData: any = CryptoJS.AES.encrypt(
              //   JSON.stringify(this.updatedUserData),
              //   environment.secretKey
              // ).toString()
              // localStorage.setItem('adminInfo', updatedUserData);
              // this.dataService.updateProfileService(this.updatedUserData)
            },
            (err: any) => {
              this.alertService.error(err.error.errorMessage)
            }
          )
        reader.readAsBinaryString(file)
      }
    }
  }

  _handleReaderLoaded_school(readerEvt: any): void {
    const binaryString: any = readerEvt.target.result
    this.base64textString = btoa(binaryString)
  }

  errorHandler(event: any): void {
    event.target.src = environment.noUserImg
    this.logoStatus = true
  }
  openLogo(id: any): void {
    const index: any = this.albumLogo.findIndex((data: any) => data.id === id)
    if (index !== -1) {
      this.lightbox.open(this.albumLogo, index, { disableScrolling: true })
    }
  }
}
